import React from "react";
import { BadgeBase } from "@reusejs/react";
import LightningSvg from "../../Icons/LightningSvg";
import SearchComponent from "../SearchComponent";
import SectionLayoutWrapper from "../../layouts/SectionLayoutWrapper";
import HomeSlider from "../HomeSlider";

export default function HeroComponent(props: any) {
  return (
    <div className="bg-hero-pattern bg-gray-50">
      <SectionLayoutWrapper
        firstChild={
          <div className="sm:h-screen w-full flex flex-col lg:justify-between">
            <div className="flex-col flex justify-center w-full lg:mt-20">
              <div className="text-start mb-2 lg:text-left">
                <BadgeBase
                  label={"Auctions"}
                  badgeSuffix={<LightningSvg width="12" height="13" />}
                  badgeBaseClasses={{
                    borderRadius: "rounded-md",
                  }}
                />
              </div>
              <div className="text-3xl sm:text-6xl font-extrabold flex flex-col">
                <h1 className="text-start lg:text-left text-blue-900">
                  Bank Auctions
                </h1>
                <h1 className="text-start lg:text-left text-blue-600">
                  Made Simple
                </h1>
              </div>

              <div className="text-start font-normal lg:text-left text-gray-500 mt-5 lg:pr-84">
                The most transparent way to find and bid for the property of
                your choice.
              </div>
            </div>
            <div className="relative lg:absolute z-[9] mt-10 lg:top-96 ">
              <SearchComponent />
            </div>
          </div>
        }
        secondChild={
          <HomeSlider textOverImage={false} allBanners={props.allBanners} />
        }
      />
    </div>
  );
}
